( function( global, $ ) {

    $('[data-href]').on('click', function() {
        window.location.replace($(this).attr('data-href'));
    });

    if (!global.methods.isMobile('breakpoint', 'md')) {
        $('[gr-mobile-link]').css('cursor', 'default');
    }

    $('[gr-mobile-link]').on('click', function(e) {
        if (!global.methods.isMobile('breakpoint', 'md')) {
            e.preventDefault();
        }
    });

}( window.groots, jQuery ));
